"use client";

import { useQuery, type UseQueryResult } from "@tanstack/react-query";

import { fetchAutomationsBilling } from "../../client/manager/automations";
import type { AutomationsBilling } from "../../models/automations-billing";
import { automationsKeys } from "./automationsQueryKeys";

/** The subscription's card on file and Automations charges for one comedian. */
export function useAutomationsBilling(
  comedianId: string,
  opts?: { enabled?: boolean }
): UseQueryResult<AutomationsBilling> {
  return useQuery({
    queryKey: automationsKeys.billing(comedianId),
    queryFn: () => fetchAutomationsBilling(comedianId),
    enabled: !!comedianId && (opts?.enabled ?? true),
    staleTime: 2 * 60 * 1000,
    retry: false,
  });
}
